import { reportsStoreFeatureName } from '../consts';

export const safeReportsStateSelector = (state: any, namespace: string, initilalState: any) => {
  const reportsState = reportsStoreFeatureName in state ? state[reportsStoreFeatureName] : null;
  if (reportsState && namespace in reportsState) {
    return reportsState[namespace];
  }
  return initilalState;
};
